export default __webpack_public_path__ + "static/media/StandWeSpeak.bb1055a8.webp";